import { render, staticRenderFns } from "./DetailUjianPsikologi.vue?vue&type=template&id=314942bf"
import script from "./DetailUjianPsikologi.vue?vue&type=script&lang=js"
export * from "./DetailUjianPsikologi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports